import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dismissNetworkNotice, isNetworkNoticeVisible, onNetworkNotice } from '@/lib/networkNotice';

/**
 * Всплывашка «Нет соединения с интернетом» — снизу по центру, одна на раз (25.09.2026).
 * Правила показа и почему она рядом с полосой «Нет сети» — в `lib/networkNotice.ts`.
 *
 * Смонтирована один раз в `main.tsx`, вне кабинета: вход без сети тоже должен сказать правду.
 *
 * ⚠️ На телефоне — над нижним меню кабинета (`app-dock`, ≈62 px + полоса жеста): тот же отступ, что у
 * `.safe-main` снизу. От `md` меню нет — ближе к краю.
 * ⚠️ `translate="no"` и текст только внутри `<span>` — от переводчика браузера (техдолг 263).
 * ⚠️ `data-native-video-cover` — как у `OfflineBar`: нативный ролик урока лежит поверх страницы
 * и иначе закрыл бы сообщение (`lib/inlineVideoNative.ts`).
 */
export function NetworkToast() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(isNetworkNoticeVisible);

  useEffect(() => onNetworkNotice(setVisible), []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      translate="no"
      data-native-video-cover=""
      data-network-toast=""
      className="pointer-events-none fixed inset-x-0 bottom-[calc(4.75rem_+_var(--sa-bottom))] z-50 flex justify-center px-4 md:bottom-6"
    >
      <div className="pointer-events-auto flex max-w-md items-center gap-3 rounded-2xl bg-inverse-surface py-3 pl-4 pr-2 text-sm font-medium text-inverse-on-surface shadow-lg">
        <span className="material-symbols-outlined text-lg" aria-hidden="true">wifi_off</span>
        <span>{t('errors.network')}</span>
        <button
          type="button"
          onClick={dismissNetworkNotice}
          aria-label={t('common.close')}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full opacity-80 hover:opacity-100"
        >
          <span className="material-symbols-outlined text-lg" aria-hidden="true">close</span>
        </button>
      </div>
    </div>
  );
}
